import Vue from 'vue'
import Router from 'vue-router'
import Login from "../pages/Login";
import NotFound from "../pages/Error/NotFound";
import storage from '../utils/storage'

Vue.use(Router);
// 未登录路由

let root = [];
let packageRouter = storage.getParse('router');
// 初始化路由
if (packageRouter && packageRouter.length) {
  // 处理数据
  packageRouter.forEach(function (menu) {
    let component = '';
    menu.path.split('/').filter(function (el) {
      return el !== '';
    }).forEach(function (item) {
      component += item.charAt(0).toUpperCase() + item.slice(1);
    });
    // 添加路由
    root.push({
      path: menu.path,
      meta: {name: menu.title,operation:menu.operation},
      component: () => import('@/pages/' + component)
      // component: resolve => require(['@/pages/' + component], resolve) // 懒加载
    })
  })
}

//默认加载第一个
root.unshift(root[0] ? {path: '/', redirect: root[0].path} : {path: '/'})
// 追加其他
root.push({
  path: '/login',
  component: Login
}, {
  path: '*',
  component: NotFound
})

const routerConfig = {
  // mode: 'history',
  linkActiveClass: 'active',
  routes: root
};

let router = new Router(routerConfig);

// 路由导航守卫
router.beforeEach((to, from, next) => {

  if (to.path === '/login') {
    next();
    return
  }
  if (!storage.get('token')) {
    return next({path: '/login'})
  }
  next(true)
});


export default router
